import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '../../../atoms/PrimaryButton'
import SecondaryButton from '../../../atoms/SecondaryButton'
import FullScreenPopup from '../../../organisms/FullScreenPopup'
import ProductCommonContext from '../../../../context/common/commonContext'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../../common/components'
import Loaders from '../../../molecules/Loaders'
import CustomCommonContext from '../../../../../custom/context/common/commonContext'
import BaseActionPage from '../../../species/dynamic/common/BaseActionPage'
import AuctionContext from '../../../../context/template/auction/auctionContext'
import ProductContext from '../../../../context/product/productContext'
import SettingContext from '../../../../context/setting/settingContext'
import SellerBidContext from '../../../../context/bid/bidContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'

let randomVariable = Math.random()

const AuctionFieldsView = (props) => {
    const auctionContext = useContext(AuctionContext)
    const settingContext = useContext(SettingContext)
    const sellerBidContext = useContext(SellerBidContext)

    const { bid_increments, getAllBidIncrements } = settingContext
    const {
        single_auction,
        auction_projects,
        getSingleAuction,
        getAllAuctProjects,
        auctionAction,
        responseStatus: AuctionResponseStatus,
    } = auctionContext
    const {
        all_increments,
        bidIncrementAction,
        changeBidIncrementStatus,
        responseStatus: responseStatusSellerBid,
    } = sellerBidContext
    const ups_engine_carrier_id = 'se-719206'
    const ups_engine_carrier_code = 'ups'

    const usps_engine_carrier_id = 'se-719205'
    const usps_engine_carrier_code = 'stamps_com'
    const station_carrier_code = 'fedex'
    const station_service_code = 'fedex_ground'
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [tempArray, setTempArray] = useState([])

    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])

    const [formikValues, setFormikValues] = useState({})

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])
    const [singleRecord, setSingleRecord] = useState([])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = {
            id: 0,
            project_status: 'draft',
            engine_carrier_id: '',
            engine_carrier_code: '',
            station_carrier_code: '',
            station_service_code: '',
            // shipping: 'shipEngine',
        }

        customValidationTemp = {
            ...props.customValidation,
            date_added: Yup.date('Please enter valid date!')
                .nullable()
                .required('Required!'),
            date_closed: Yup.date('Please enter valid date!')
                .min(Yup.ref('date_added'), 'Should be greater than start Time')
                .nullable()
                .required('Required!'),
            ending_enable: Yup.boolean(),
            ending_items: Yup.number().when('ending_enable', {
                is: (end) => end === true,
                then: Yup.number().min(0, 'Not valid!').required('Required!'),
            }),
            ending_mins: Yup.number().when('ending_enable', {
                is: (end) => end === true,
                then: Yup.number().min(0, 'Not valid!').required('Required!'),
            }),
            local_pickup_check: Yup.boolean().when('shipping_check', {
                is: false,
                then: Yup.boolean().oneOf(
                    [true],
                    'Enable Local Pickup or Shipping'
                ),
            }),
            local_pickup_slot_timeframe: Yup.number().when(
                'local_pickup_check',
                {
                    is: true,
                    then: Yup.number()
                        .integer('Must be an integer')
                        .min(0, 'Not valid!')
                        .required('Required!'),
                }
            ),
            local_pickup_appt_per_slot: Yup.number().when(
                'local_pickup_check',
                {
                    is: true,
                    then: Yup.number()
                        .integer('Must be an integer')
                        .min(0, 'Not valid!')
                        .required('Required!'),
                }
            ),
            local_pickup_start_hour: Yup.string()
                .nullable()
                .when('local_pickup_check', {
                    is: true,
                    then: Yup.string().nullable().required('Required!'),
                }),
            local_pickup_end_hour: Yup.string()
                .nullable()
                .when('local_pickup_check', {
                    is: true,
                    then: Yup.string().nullable().required('Required!'),
                }),
            ship_station: Yup.string().when('shipping_check', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            ship_service: Yup.string().when('ship_station', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            station_package_code: Yup.string().when('ship_station', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            station_warehouse: Yup.string().when('ship_station', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((mapValue) => {
                if (mapValue.name === 'date_closed') {
                    mapValue.minDate = dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )
                    mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )}`
                    mapValue.disablePast = true
                } else if (mapValue.name === 'date_added') {
                    mapValue.disablePast = true
                } else if (mapValue.name === 'ending_items') {
                    mapValue.disabled = formikValues.ending_enable
                        ? false
                        : true
                } else if (mapValue.name === 'ending_mins') {
                    mapValue.disabled = formikValues.ending_enable
                        ? false
                        : true
                } else if (mapValue.name === 'local_pickup_dates') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_start_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_end_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_appt_per_slot') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_slot_timeframe') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'ship_station') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6 mb-3`
                } else if (mapValue.name === 'station_package_code') {
                    mapValue.class = `${
                        formikValues.ship_station ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'station_warehouse') {
                    mapValue.class = `${
                        formikValues.ship_station ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'ship_service') {
                    mapValue.class = `${
                        formikValues.ship_station ? '' : 'd-none'
                    } col-sm-6 col-6`
                }
            })
            if (formikValues.shipping_carrier) {
                if (formikValues.shipping_carrier === 'ups') {
                    formikValues.engine_carrier_id = ups_engine_carrier_id
                    formikValues.engine_carrier_code = ups_engine_carrier_code
                } else if (formikValues.shipping_carrier === 'usps') {
                    formikValues.engine_carrier_id = usps_engine_carrier_id
                    formikValues.engine_carrier_code = usps_engine_carrier_code
                } else {
                    formikValues.engine_carrier_id = ''
                    formikValues.engine_carrier_code = ''
                }
            } else if (formikValues.ship_station) {
                formikValues.station_carrier_code = station_carrier_code
                formikValues.station_service_code = station_service_code
            }
            setReload(!reload)
            // setMapDataValue(tempMapData)
            // setResetMapData(true)
        }
    }, [formikValues])

    useEffect(() => {
        let dataValue = [
            {
                active: 1,
                class: 'col-sm-6 col-12',
                is_default: 1,
                is_required: 1,
                label: 'Catalogue  Name *',
                name: 'template_name',
                placeholder: 'Enter your Catalogue Name',
                type: 'text',
            },
            ...props.fieldValue,
        ]
        if (dataValue.length) {
            // this is not appending. Check this code
            dataValue
                .filter((inner) => inner.name !== 'project_id')
                .map((data, index) => {
                    if (
                        data.name === 'title' ||
                        data.name === 'template_name'
                    ) {
                        data.is_required = 1
                    } else {
                        data.is_required = 0
                    }
                })
            setTempArray(dataValue)
            setReload(!reload)
            setIsLoading(false)
        }
    }, [props.fieldValue])
    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = () => {
        setIsLoading(true)
        const value = formikValues
        if (data.status === 'newTemplate') {
            value.id = 0
        }
        if (value.market_status === 'draft') {
            if (value.date_added) {
                value.date_added = moment(
                    value.date_added,
                    'MM-DD-YYYY h:mm a'
                ).format()
            } else if (value.date_closed) {
                value.date_closed = moment(
                    value.date_closed,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
        }

        auctionAction(value)
    }

    const formSubmit = (value, data) => {
        let newValue = formikValues
        newValue.market_status = data
        newValue.project_status = data
        setFormikValues(newValue)
        // setFormikValues({
        //     ...formikValues,
        //     market_status: data,
        // })
        submitFunction()
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status !== 'editTemplate') {
            if (data.status === 'newTemplate') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data.id])

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id) {
            if (
                data.status === 'editTemplate' &&
                single_auction?.record?.market_status === 'draft'
            ) {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: 'Save as Draft',
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Submit',
                    additionalValue: 'open',
                })
            }
            if (
                data.status === 'editTemplate' &&
                single_auction?.record?.market_status === 'open'
            ) {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            }
        } else {
            // buttonDataTemp.push({
            //     type: 'button',
            //     style: 'secondary',
            //     label: 'Save as Draft',
            //     additionalValue: 'draft',
            // })
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Submit',
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, data, single_auction])

    useEffect(() => {
        // setIsLoading(true)
        if (data.popup) {
            if (data.id && data.status === 'editTemplate') {
            } else if (data.status === 'newTemplate') {
            }
        }
    }, [data.popup])

    useEffect(() => {
        if (props.customBidIncrement) {
            getAllBidIncrements({
                searchterm: '',
                page: 1,
                limit: 100,
                order: '',
                orderby: '',
            })
        }
    }, [props.customBidIncrement])

    useEffect(() => {
        if (AuctionResponseStatus) {
            if (AuctionResponseStatus.status === 'success') {
                if (
                    AuctionResponseStatus.data.auction_id &&
                    props.customBidIncrement
                ) {
                    let bidIncrements = bid_increments.records.map(
                        (increment) => {
                            delete increment.id
                            let eventType = { ...increment }
                            eventType.auction_id =
                                AuctionResponseStatus.data.auction_id
                            return eventType
                        }
                    )
                    bidIncrementAction(
                        { array: true, data: bidIncrements },
                        true
                    )
                }
            }
        }
    }, [AuctionResponseStatus, bid_increments])

    return props.standalone ? (
        <>
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <BaseActionPage
                                arrayValue={tempArray}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                editFunction={getSingleAuction}
                                editValue={single_auction}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                buttonAction={buttonData}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </>
    ) : (
        <FullScreenPopup
            modaltitle={
                data.status === 'newTemplate'
                    ? 'ADD NEW AUCTION TEMPLATE'
                    : `EDIT AUCTION TEMPLATE`
            }
            open={
                data.status === 'newTemplate' || data.status === 'editTemplate'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                setIsLoading(false), toggleFullScreenPopup(false, '', 0)
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <BaseActionPage
                                arrayValue={tempArray}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                editFunction={getSingleAuction}
                                editValue={single_auction}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                buttonAction={buttonData}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default AuctionFieldsView
